import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

// Gerarchia ruoli
export const ROLES = {
  UTENTE: "utente",
  SOCIO: "socio",
  COLLABORATORE: "collaboratore",
  DIRETTIVO: "direttivo",
  AMMINISTRAZIONE: "amministrazione",
  ADMIN: "admin", // compat
};
const LEVEL = { utente: 1, socio: 2, collaboratore: 3, direttivo: 4, amministrazione: 5, admin: 5 };

export const ROLE_LABELS = {
  utente: "Utente",
  socio: "Socio/a",
  collaboratore: "Collaboratore/trice",
  direttivo: "Consiglio Direttivo",
  amministrazione: "Amministrazione",
  admin: "Amministrazione",
};

export const isAdmin = (role) => role === "admin" || role === "amministrazione";
export const isStaff = (role) => LEVEL[role] >= 3;
export const isMemberPlus = (role) => LEVEL[role] >= 2;
export const roleAtLeast = (role, min) => (LEVEL[role] || 0) >= (LEVEL[min] || 0);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("vv_user");
    if (stored) setUser(JSON.parse(stored));
    setReady(true);
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("vv_token", data.token);
    localStorage.setItem("vv_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return data;
  };

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("vv_user", JSON.stringify(data));
      setUser(data);
      return data;
    } catch {
      return null;
    }
  };

  const logout = () => {
    localStorage.removeItem("vv_token");
    localStorage.removeItem("vv_user");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, refreshMe, logout, ready }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
